import Home from 'in-meeting-experience-ui-components/components/home/Home/Home';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { routes, unauthorizedRoutesParam } from '../constants/routes';
import useOauthPopup from '../hooks/useOauthPopup';
import { useQueryParams } from '../hooks/useQueryParams';
import { getExternalAuthUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const OauthRedirect = () => {
  const dispatch = useDispatch();
  const {
    portalId
  } = useQueryParams();
  const [url, setUrl] = useState('');
  const openPopUp = useOauthPopup();
  const openUrlFunction = () => {
    if (url) {
      openPopUp(url);
    }
  };
  useEffect(() => {
    if (portalId) {
      setUrl(getExternalAuthUrl(portalId));
    } else {
      setUrl(getExternalAuthUrl());
    }
  }, [portalId, dispatch]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "RECONNECT_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Home, {
      unauthorizedRoutesParam: unauthorizedRoutesParam,
      accountsRoute: routes.accounts,
      ctaButtonText: "reconnect.button",
      ctaFunction: openUrlFunction
    })
  });
};
export default OauthRedirect;